import cx from 'classnames';
import PieChart from 'react-minimal-pie-chart';

import styles from '../../styles/plan/valueBreakup.scss';
import { makeid, randomColors } from '../../constants';

const ValueBreakup = (props: any) => {
  return (
    <div className={cx(styles['value-breakup'], 'row')}>
      <div className="large-4 medium-6 small-6 columns">
        <PieChart
          lineWidth={40}
          style={{ maxWidth: '150px' }}
          data={props.data.map((item: any, idx: number) => {
            return {
              value: Number(item.value),
              color: randomColors[idx],
            };
          })}
        />
      </div>
      <div className="large-8 medium-6 small-6 columns">
        <ul className={styles.legend}>
          {(props.data || []).map((item: any, idx: number) => (
            <li key={makeid()} className={styles['value-row']}>
              <span
                className={styles.color}
                style={{
                  background: randomColors[idx],
                }}
              />
              <label className={styles.label}>
                {item.label}: <b>{item.value}%</b>
              </label>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ValueBreakup;



// WEBPACK FOOTER //
// ./components/plan/valueBreakup.tsx